import { Component, OnInit } from '@angular/core';
import { CstemapiService } from '../cstemapi.service';

@Component({
  selector: 'app-credit',
  templateUrl: './credit.component.html',
  styleUrls: ['./credit.component.scss']
})
export class CreditComponent implements OnInit {

  customOptions: any = {};
  team_r: any = [];
  team_i: any = [];
  team_a: any = [];
  team_ak: any = [];
  team_fun: any = [];

  constructor(public cstemapi: CstemapiService) {
    this.customOptions = {
      items: 3,
      loop: true,
      autoplay: true,
      autoplayHoverPause: true,
      animateOut: 'slideOutDown',
      animateIn: 'flipInX',
      margin: 30,
      stagePadding: 30,
      smartSpeed: 450,
      autoWidth: true,
      // responsive: {
      //   0: {
      //     items: 1
      //   },
      //   400: {
      //     items: 2
      //   },
      //   740: {
      //     items: 3
      //   },
      //   940: {
      //     items: 4
      //   }
      // },
    }

    this.team_fun = [
      { name: 'Ministry of New and Renewable Energy (MNRE)', role: 'https://mnre.gov.in/', image: 'team/Picture1.png', type: 'R' },
      { name: 'Department of Science and Technology (DST)', role: 'http://dst.gov.in/', image: 'team/Picture2.png', type: 'R' },
      { name: 'Good Energies Foundation', role: 'https://www.goodenergies.org/', image: 'team/Picture3.png', type: 'R' },
      { name: 'International Development Research Centre (IDRC)', role: 'https://www.idrc.ca/en', image: 'team/Picture4.png', type: 'R' },
      { name: 'Oak Foundation', role: 'http://www.oakfnd.org/', image: 'team/Picture5.png', type: 'R' },
      { name: 'National Renewable Energy Laboratory (NREL)', role: 'https://www.nrel.gov/', image: 'team/Picture6.png', type: 'R' }
    ]


    this.team_r = [
      { name: 'Harshid Sridhar', role: 'Overall Conceptual Design, Solar and Financial Model', image: 'team/Harshid.jpg', type: 'R' },
      { name: 'Dr. Vinay Kandagal', role: 'Battery and Load Model', image: 'team/vinays.jpg', type: 'R' },
      { name: 'Dr. Ammu Susana Jacob', role: 'Battery and Load Model', image: 'team/ammu.jpg', type: 'R' }
    ]

    this.team_i = [
      { name: 'Rohith Sridhar', role: 'Backend Development', image: 'team/rohit.jpg', type: 'I' },
      { name: 'Mohana Kumari', role: 'User Interface Design', image: 'team/Mohana.jpg', type: 'I' },
      { name: 'Sunil Kumar Chaurasia', role: 'Backend Development', image: 'team/Sunil.jpg', type: 'I' },
      { name: 'Bhawna Welturkar', role: 'Graphics Design', image: 'team/Bhawna-profile-1.jpg', type: 'I' },
      { name: 'Lydia Sareena:', role: 'Graphic Video', image: 'team/lydia.png', type: 'I' },
      { name: 'Udita Palit', role: 'Graphics Design', image: 'team/Udita.jpg', type: 'I' }
    ]

    this.team_a = [
      { name: 'Thirumalai N.C', role: 'Solar and Financial Model', image: 'team/Thirumallai.jpg', type: 'A' },
      { name: 'Dr. Mridula Dixit Bharadwaj', role: 'Battery Model', image: 'team/Mridula.jpg', type: 'A' },
      { name: 'Ranganathan P', role: 'IT', image: 'team/Ranganatha.jpg', type: 'A' },
      { name: 'Surbhi Sinha', role: 'IT', image: 'team/Surbhi.jpg', type: 'A' },
      { name: 'Dr. K.C. Bellarmine', role: 'Financial Model', image: 'team/Bellaramine.jpg', type: 'A' },
      { name: 'Sreerekha Pillai', role: 'CPE', image: 'team/Sreerekha.jpg', type: 'A' }
    ]

    this.team_ak = [
      { name: 'Prof. M.A. Ramasamy', role: '', image: 'team/ramaswamy.jpg', type: 'AK' },
      { name: 'Dr. Anshu Bharadwaj', role: '', image: 'team/anshu.jpg', type: 'AK' },
      { name: 'Dr. Jai Asundi', role: '', image: 'team/Jai.jpg', type: 'AK' },
      { name: 'Suresh N.S', role: '', image: 'team/Suresh.jpg', type: 'AK' },
      { name: 'Vaishalee Dash', role: '', image: 'team/Vaishalee.jpg', type: 'AK' },
      { name: 'Badri S Rao', role: '', image: 'team/badri.jpg', type: 'AK' },
      { name: 'Merlin Francis', role: '', image: 'team/Merlin.jpg', type: 'AK' },
      { name: 'Devaditya Bhattacharya', role: '', image: 'team/Devaditya.jpg', type: 'AK' },
      { name: 'Abhinav Misra ', role: '', image: 'team/Abhinav Misra.jpg', type: 'AK' },
      { name: 'India Ashok', role: '', image: 'team/India.jpg', type: 'AK' },
      { name: 'Shramana Dey', role: '', image: 'team/Shramana Dey.jpg', type: 'AK' },
      { name: 'DR. PARVEEN KUMAR', role: '', image: 'team/Praveen.png', type: 'AK' },
    ]
  }
  
  
  
  
  ngOnInit() {
  }

}
